module.exports = require('../ifCond2').ifCond2Helper;
